import React from 'react';
import { sanitize } from "§/src/utils/functions";
import { sitesUrls } from "§/src/utils/sitesUrls";

const SchemaBreadcrumb = ({ breadcrumbs }) => {
  if (!breadcrumbs) return null;

  const siteLang = process.env.GATSBY_SITE_LANG; // Lingua del sito per il baseUrl
  const siteInfo = sitesUrls(siteLang);
  const baseUrl = siteInfo.url;
  const wpUrl = siteInfo.wpUrl;
  const wpUrlBuggy = siteInfo.wpUrlBuggy;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => {
      let fullUrl = ''; // Inizializzazione di fullUrl

      if (crumb.url === '/' || crumb?.url?.startsWith('/')) {
        // Constructs a complete URL from relative paths, ensuring no double slashes.
        fullUrl = baseUrl + (baseUrl.endsWith('/') ? crumb?.url?.substring(1) : crumb.url);
      } else if (crumb?.url?.startsWith(baseUrl)) {
        // Uses the URL as is if it already starts with the base URL.
        fullUrl = crumb.url;
      } else if (crumb?.url?.startsWith(wpUrl)) {
        // Replaces the WordPress URL with the site's base URL.
        fullUrl = crumb?.url?.replace(wpUrl, baseUrl);
      } else if (crumb?.url?.startsWith(wpUrlBuggy)) {
        // Corrects URLs known to be problematic by replacing them with the base URL.
        fullUrl = crumb?.url?.replace(wpUrlBuggy, baseUrl);
      } else if (crumb?.url?.startsWith('https://')) {
        // Replaces any other domain with the base URL, focusing on HTTPS URLs.
        fullUrl = crumb?.url?.replace(/^https?:\/\/[^\/]+/, baseUrl);
      } else {
        // Default: append the crumb URL to the base URL if no conditions are met.
        fullUrl = baseUrl + crumb.url;
      }

      return {
        "@type": "ListItem",
        "position": index + 1,
        "name": sanitize(crumb.text),
        "item": fullUrl
      };
    })
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </script>
  );
};

export default SchemaBreadcrumb;
